import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import type { IncidenceOptionsType } from 'modules/bookkeepers/lib/incidenceOptions'
import { translatedHelpers } from 'modules/bookkeepers/lib/translationHelpers'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'

interface LeaveIncidenceOptions {
  loading: boolean
  leaveIncidenceOptions: IncidenceOptionsType[]
}

export const useGetLeaveIncidenceOptions = (
  companyId: string,
  isBookkeeperView: boolean
): LeaveIncidenceOptions => {
  const { loading } = useAsyncData(
    () =>
      Promise.all([
        leaveTypes.fetch({
          data: {
            bookkeeper_view: isBookkeeperView,
            active: true,
          },
        }),
      ]),
    []
  )
  const leaveIncidenceOptions = leaveTypes
    .filter((model) => {
      return String(model.attributes.company_id) === companyId
    })
    .map((model) => {
      return {
        id: model.attributes.id,
        name: model.attributes.translated_name,
        disabled: false,
        identifier: model.attributes.identifier,
        ...translatedHelpers(model.attributes.translated_name),
      }
    })

  return { loading, leaveIncidenceOptions }
}
